module.exports = __webpack_public_path__ + "media/virtual_show/vShowLogoLight-54ebb1eb.png";